import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { Button, Form, Modal } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { navigateToParentRoute } from "@teamprevent/common/routing/actions";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { routeIdSelector as customerIdSelector } from "../../../crud/customer/selectors";
import { taskSelector } from "../../selectors";
import { ohCaseSelector } from "../../../crud/ohCase/selectors";
import { SendLetterToGPSpecialistModel } from "../../../generalPractitionerSpecialistInfo/models";
import { SEND_LETTER_TO_GP_SPECIALIST } from "../../../generalPractitionerSpecialistInfo/actionTypes";
import { sendLetterToGPSpecialist } from "../../../generalPractitionerSpecialistInfo/actions";
import { AddTaskModal } from "../../../tasks/components/AddTaskModal";

export const SendLetterToGeneralPractitionerSpecialistModal: React.FunctionComponent = () => {

    const [isSendLetterModalOpen, setIsSendLetterModalOpen] = React.useState<boolean>(true);
    const [letterSentDetails, setLetterSentDetails] = React.useState<string>(null);
    const [showErrors, setShowErrors] = React.useState<boolean>(false);
    const [openAddTaskModal, setOpenAddTaskModal] = React.useState<boolean>(false);

    const customerId = useSelector(customerIdSelector);
    const ohCase = useSelector(ohCaseSelector);
    const task = useSelector(taskSelector);

    React.useEffect(() => {
        return resetState;
    }, []);

    const resetState = () => {
        setIsSendLetterModalOpen(false);
        setLetterSentDetails(null);
        setShowErrors(false);
        setOpenAddTaskModal(false);
    };

    const dispatch = useDispatch();

    const onSendLetterModalSubmit = () => {
        setShowErrors(true);

        if (task?.id && ohCase?.id && letterSentDetails) {
            const model: SendLetterToGPSpecialistModel = { letterSentDetails };

            dispatch(sendLetterToGPSpecialist(customerId, ohCase.id, task.id, model));

            setOpenAddTaskModal(true);
        }
    };

    const onSendLetterClose = () => {
        dispatch(navigateToParentRoute());
    };

    const onAddTaskModalClose = () => {
        dispatch(navigateToParentRoute());
    };

    return (
        <>
            <Modal open={isSendLetterModalOpen}>
                <Modal.Header content={task?.description} />
                <Modal.Content>
                    <Form loading={!task}>
                        <Input.Textarea label="Notes" value={letterSentDetails} required showErrors={showErrors} onChange={setLetterSentDetails} />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <IsLoadingButton requestNames={SEND_LETTER_TO_GP_SPECIALIST} content="Action Task" onClick={onSendLetterModalSubmit} />
                    <Button content="Cancel" onClick={onSendLetterClose} />
                </Modal.Actions>
            </Modal>
            <AddTaskModal
                open={openAddTaskModal}
                customerId={task?.customer?.id}
                ohCase={ohCase}
                assignmentOptionRequired={true}
                onClose={onAddTaskModalClose}
            />
        </>
    );
};
